
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface SearchInstancesProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const SearchInstances: React.FC<SearchInstancesProps> = ({ searchQuery, setSearchQuery }) => {
  return (
    <div className="flex w-full items-center space-x-2 mb-6">
      <div className="relative flex-1">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search instances..."
          className="pl-8"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchInstances;
